module.exports = __webpack_public_path__ + "static/media/reroute.03129d42.svg";